import { faker } from '@faker-js/faker';
import { sample } from 'lodash';

// ----------------------------------------------------------------------

const usuarios = [...Array(24)].map((_, index) => ({
  id: faker.datatype.uuid(),
  nombre: faker.name.fullName(),
  email: faker.internet.exampleEmail(),
  celular: faker.phone.number(),
  fechacreacion: faker.date.weekday(),
  estatus: sample(['Activo', 'Inactivo']),
}));

export default usuarios;
